import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";

const StaffMenu = () => {
  return (
    <Row>
      <Col style={{ marginTop: "25px" }} xs={12}>
        <h4>STAFF MENU</h4>
      </Col>
      <Col style={{ marginTop: "5px" }} xs={12}>
        <Row>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Home</h5>
            <Link to="/staff" className="sideBarMenuItem">
              <span>Home</span>
            </Link>
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Update Litigants</h5>
            <Link to="/staff/UpdateLitigantInfo" className="sideBarMenuItem">
              <span>Update litigant personal info</span>
            </Link>
            <br />
            <Link
              to="/staff/UpdateLitigantQuestionnaire"
              className="sideBarMenuItem"
            >
              <span>View/Edit litigant questionnaires</span>
            </Link>
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Attorneys</h5>
            <Link to="/staff/ApproveAttorneys" className="sideBarMenuItem">
              <span>Approve/Deny attorney registration</span>
            </Link>
            <br />
            <Link to="/staff/UpdateAttorneyInfo" className="sideBarMenuItem">
              <span>Update attorney info</span>
            </Link>

            <br />
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Appointments</h5>
            <Link to="/staff/createAppointment" className="sideBarMenuItem">
              <span>Create/Edit appointments</span>
            </Link>
            <br />
          </Col>
          <Col xs={12}>
            <hr />
          </Col>
          <Col xs={12}>
            <h5>Sign Out</h5>
            <Link to="/" className="sideBarMenuItem">
              <span>Sign out</span>
            </Link>
            <br />
          </Col>
          <Col xs={12} className="psInfo"></Col>
        </Row>
      </Col>
    </Row>
  );
};

export default StaffMenu;
